import { Typography } from 'antd'
import * as styles from './empty-post.module.scss'

const { Text } = Typography

interface EmptyPostProps {
    title: string
}

export const EmptyPost = ({ title }: EmptyPostProps) => {
    return (
        <div className={styles.block}>
            <Text className={styles.circle}>●</Text>
            <Text className={styles.label}>{title}</Text>
        </div>
    )
}
